import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path d="M19.248 28.5032L7.49234 36.6835L11.6396 22.9753L0.226917 14.3228L14.5458 14.031L19.248 0.503174L23.9503 14.031L38.2692 14.3228L26.8565 22.9753L31.0038 36.6835L19.248 28.5032Z" />,
  'Star',
)
